const button = document.querySelector('.about-product__content button');
const videoModal = document.querySelector('.webinar-video');
const video = document.querySelector('.webinar-video__frame');
const html = document.documentElement;

// відкриття
button.addEventListener('click', () => {
    videoModal.classList.add('active');
    html.classList.add('hidden');

    video.play();
});

// закриття
videoModal.addEventListener('click', (e) => {
    if (e.target === videoModal) {
        videoModal.classList.remove('active');
        html.classList.remove('hidden');

        video.pause();
        video.currentTime = 0;
    }
});